import React from "react";
import axios from 'axios';
import { View, Platform, Image, KeyboardAvoidingView } from "react-native";
import { Text, Button, Dialog, Portal } from "react-native-paper";
import NetInfo from '@react-native-community/netinfo';
import * as SecureStore from 'expo-secure-store';
import * as Updates from 'expo-updates';
import * as Location from 'expo-location';
import Constants from 'expo-constants';
import * as Notifications from 'expo-notifications';
import { useSession } from "../ctx/ctx";
import { useStorageState } from "../ctx/useStorageState";
import Error500Image from "../assets/Error500.png";
import OfflineImage from "../assets/offline.png";
import DisableImage from "../assets/disable.png";
import Birthday1 from '../assets/birthday-1.gif';
import Birthday2 from '../assets/birthday-2.gif';
import Birthday3 from '../assets/birthday-3.gif';
import LoadingImage from '../assets/loading.gif';
import Logo from '../assets/logo.png';
import NoGPS from '../assets/NoGPS.png';

export const MainContext = React.createContext();

export function MainContextProvider(props) {
  const [isGpsOpen, setIsGpsOpen] = React.useState(false);
  const [isOffline, setIsOffline] = React.useState(false);
  const [appDataLoad, setAppDataLoad] = React.useState(false);
  const [[loading, session], setSession] = useStorageState('adsForm');
  const [[loadingCustomerForm, sessionCustomerForm], setSessionCustomerForm] = useStorageState('customerForm');
  const { isLoading, signOut } = useSession();
  const [isInAppUpdateOn, setIsInAppUpdateOn] = React.useState(false);
  const [isError500, setIsError500] = React.useState(false);
  const [isDisable, setIsDisable] = React.useState(false);
  const [isBirthday, setIsBirthday] = React.useState(false);
  const [birthdayStep, setBirthdayStep] = React.useState(1);
  const [userData, setUserData] = React.useState({});
  const [role, setRole] = React.useState({});
  const [addsTypes, setAddsTypes] = React.useState({});
  const [locationData, setLocationData] = React.useState({});
  const [snackbar, setSnackbar] = React.useState({ active: false, message: null });
  const [addAdsFormActive, setAddAdsFormActive] = React.useState(false);
  const [addAdsForm, setAddAdsForm] = React.useState({});
  const [addCustomerActive, setAddCustomerActive] = React.useState(false);
  const [addCustomerForm, setAddCustomerForm] = React.useState({});
  const today = new Date();

  React.useEffect(() => {
    NetInfo.addEventListener(state => {
      setIsOffline(!state.isConnected || !state.isInternetReachable);
    });    
  }, [])

  React.useEffect(() => {
    if(!isLoading) {
      checkUserLogin();
      // if(session && Object.keys(JSON.parse(session)).length > 0) {
      //   console.log(JSON.parse(session));
      //   setAddAdsFormActive(true);
      // } else {
      //   setAddAdsFormActive(false);
      // }
      // if(sessionCustomerForm && Object.keys(JSON.parse(sessionCustomerForm)).length > 0) {
      //   setAddCustomerActive(true);
      // } else {
      //   setAddCustomerActive(false);
      // }
    }
  }, [isLoading])

  React.useEffect(() => {
    async function fetchData() {
      let token = await Notifications.getExpoPushTokenAsync({
        projectId: Constants.expoConfig.extra.eas.projectId,
      });
      uploadAppFirstData(token);
    }
    if (Platform.OS !== 'web') {
      fetchData();
    }
    getAppFirstData();
  }, [])

  React.useEffect(() => {
    async function onFetchUpdateAsync() {
      try {
        const update = await Updates.checkForUpdateAsync();
        if (update.isAvailable) {
          setIsInAppUpdateOn(true);
        }
      } catch (error) {
        alert(`Error fetching latest App update: ${error}`);
      }
    }
    if (Platform.OS !== 'web') {
      onFetchUpdateAsync();
    }
  }, [])

  React.useEffect(() => {
    // const interval = setInterval(() => {
    //   (async () => {
    //     const res = await Location.hasServicesEnabledAsync();
    //     if(res) {
    //       setIsGpsOpen(false);
    //     } else {
    //       setIsGpsOpen(true);
    //     }
    //   })();
    // }, 5000);
    // return () => clearInterval(interval);
  }, []);

  const checkUserLogin = async () => {
    await axios.all([
      axios.get(`/get_my_info`),
    ])
    .then(axios.spread((userData) => {
      if(userData?.data[0]?.status !== false) {
        setUserData(userData.data[0]);
        setRole(userData.data.role);
        if(userData.data[0].birthday) {
          let toDayFormat = today.toLocaleDateString().split("/");
          let toDayShamsi = gregorian_to_jalali(parseInt(toDayFormat[2]), parseInt(toDayFormat[0]), parseInt(toDayFormat[1]));
          if(toDayShamsi === userData.data[0].birthday) {
            setIsBirthday(true);
          }
        }
      } else {
        setIsDisable(true);
      }
    }))
    .catch(handleAxiosError)
    .finally(() => {});
  }

  const getAppFirstData = async () => {
    await axios.all([
      axios.get(`/get_adds_types`),
      axios.post(`/get_Locations`, {
        ids: ["6543595e889c4a9ec46580f6"]
      })
    ])
    .then(axios.spread((adsType, locationData) => {
      setAddsTypes(adsType.data);

      let location = locationData.data;
      let data = [];
      if(location.options) {
        Object.values(location.options).map((item) => {
          data.push({key: item.value, value: item.label})
        })
      }
      setLocationData(data);
    }))
    .catch(handleAxiosError)
    .finally(() => setAppDataLoad(true));
  }

  const uploadAppFirstData = async (data) => {
    getExpertOfflineLocationData();
    await axios.all([
      axios.post(`/update_notfication-token`, {
        token: data.data
      })
    ])
    .then(axios.spread((response) => {
    }))
    .catch(handleAxiosError)
    .finally(() => {});
  }

  const getExpertOfflineLocationData = async () => {
    let data = await SecureStore.getItemAsync('TempData');
    if(data) {
      axios.all([
        axios.post(`/panel/update-expert-location`, {
          data: JSON.parse(data),
          connectionType: 'offline'
        }),
      ])
      .then(axios.spread( async (response) => {
        await SecureStore.deleteItemAsync('TempData');
      }))
      .catch(handleAxiosError)
      .finally(() => {});
    }
  }

  const saveAddAdsForm = (data) => {
    setSession(JSON.stringify(data));
    setAddAdsForm(data);
    setAddAdsFormActive(true);
  }

  const saveAddCustomerForm = (data) => {
    setSessionCustomerForm(JSON.stringify(data));
    setAddCustomerForm(data);
    setAddCustomerActive(true);
  }

  const setSnackbarActive = (status, message) => {
    setSnackbar({active: status, message: message});
  }

  const handleAxiosError = (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if(error.response.data.message === 'Unauthenticated.') {
            setUserData({});
            setRole({});
            axios.defaults.headers.common['Authorization'] = null;
            signOut();
          }
        break;
        case 403:
          setSnackbarActive(true, error.response.data.message);
        break;
        case 404:
          
        break;
        case 500:
          //setIsError500(true);
          console.error(error.response);
        break;
      }
    } else if (error.request) {
      //setIsError500(true);
      console.error(error.request);
    } else {
      //setIsError500(true);
      console.error('Error', error.message);
    }
  }

  const handleError500 = () => {
    return(
      <View style={{ flex: 1, alignItems: 'center', backgroundColor: '#fff', justifyContent: 'center' }}>
        <Image source={Error500Image} style={{ width: 178, height: 142 }} />
        <Text style={{ fontSize: 16, color: '#656564', fontFamily: 'IRANSans_Medium' }}>خطای سرور!</Text>
        <Text style={{ fontSize: 12, color: '#656564', marginTop: 4, marginBottom: 24 }}>لطفا با پشتیبانی در ارتباط باشید.</Text>
        <Button onPress={reloadApp} labelStyle={{ fontSize: 16 }} style={{ width: '48%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">تلاش مجدد</Button>
      </View>
    );
  }

  const handleOfflinePage = () => {
    return (
      <View style={{ flex: 1, alignItems: 'center', backgroundColor: '#fff', justifyContent: 'center' }}>
        <Image source={OfflineImage} style={{ width: 178, height: 142 }} />
        <Text style={{ fontSize: 16, color: '#656564', fontFamily: 'IRANSans_Medium' }}>ارتباط برقرار نشد!</Text>
        <Text style={{ fontSize: 12, color: '#656564', marginTop: 4, marginBottom: 24 }}>لطفا اتصال خود به اینترنت را بررسی نمایید.</Text>
        <Button onPress={reloadApp} labelStyle={{ fontSize: 16 }} style={{ width: '48%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">تلاش مجدد</Button>
      </View>
    );
  }

  const handleDisablePage = () => {
    return (
      <View style={{ flex: 1, alignItems: 'center', backgroundColor: '#fff', justifyContent: 'center' }}>
        <Image source={DisableImage} style={{ width: 178, height: 142 }} />
        <Text style={{ fontSize: 16, color: '#656564', fontFamily: 'IRANSans_Medium' }}>عدم دسترسی!</Text>
        <Text style={{ fontSize: 12, color: '#656564', marginTop: 4, marginBottom: 24 }}>حساب شما غیرفعال می باشد.</Text>
        <Button onPress={reloadApp} labelStyle={{ fontSize: 16 }} style={{ width: '48%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">تلاش مجدد</Button>
      </View>
    );
  }

  const handleBirthDay = (step) => {
    switch (step) {
      case 1:
        return (
          <View style={{ flex: 1, backgroundColor: '#fff', alignItems: 'center', justifyContent: 'space-between' }}>
            <Image source={Birthday1} style={{ width: '100%', height: '85%' }} />
            <View style={{ paddingHorizontal: 18, paddingBottom: 16, width: '100%', height: '15%', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Button onPress={() => setBirthdayStep(step + 1)} labelStyle={{ fontSize: 16 }} style={{ width: '100%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">بعدی</Button>
            </View>
          </View>
        );
      break;
      case 2:
        return (
          <View style={{ flex: 1, alignItems: 'center', backgroundColor: '#fff', justifyContent: 'space-between' }}>
            <View style={{ width: '100%', height: '85%', justifyContent: 'center', alignItems: 'center' }}>
              <Image source={Birthday2} style={{ width: 246, height: 246 }} />
            </View>
            <View style={{ paddingHorizontal: 18, paddingBottom: 16, width: '100%', height: '15%', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Text style={{ fontSize: 14, textAlign: 'left', width: '100%', color: '#5B5E63', fontFamily: 'IRANSans_Medium', marginBottom: 12 }}>کارشناس گرامی!</Text>
              <Text style={{ fontSize: 14, textAlign: 'left', width: '100%', color: '#5B5E63', marginBottom: 20 }}>تولد شما بی شک بهانه ای شد برای قدردانی از حضور شما در 40 ستون با آرزوی موفقیت، تولدتان را تبریک می گوییم.</Text>
              <Button onPress={() => setBirthdayStep(step + 1)} labelStyle={{ fontSize: 16 }} style={{ width: '100%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">بعدی</Button>
            </View>
          </View>
        );
      break;
      case 3:
        return (
          <View style={{ flex: 1, alignItems: 'center', backgroundColor: '#fff', justifyContent: 'space-between' }}>
            <View style={{ width: '100%', height: '85%', justifyContent: 'center', alignItems: 'center' }}>
              <Image source={Birthday3} style={{ width: 246, height: 246 }} />
            </View>
            <View style={{ paddingHorizontal: 18, paddingBottom: 16, width: '100%', height: '15%', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Text style={{ fontSize: 14, textAlign: 'left', width: '100%', color: '#5B5E63' }}>تولد شروعی دوباره است؛</Text>
              <Text style={{ fontSize: 14, textAlign: 'left', width: '100%', color: '#5B5E63' }}>و عهدی تازه برای دنبال کردن اهداف با تلاش بیشتر! شما فرد خاصی هستید و امروز خاص ترین روز زندگی تان.</Text>
              <Text style={{ fontSize: 14, textAlign: 'left', width: '100%', color: '#5B5E63', fontFamily: 'IRANSans_Medium', marginBottom: 24 }}>سالروزتان مبارک!</Text>
              <Button onPress={() => setIsBirthday(false)} labelStyle={{ fontSize: 16 }} style={{ width: '100%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">بستن</Button>
            </View>
          </View>
        );
      break;
    }
  }

  const reloadApp = async () => {
    if (Platform.OS === 'web') {
      location.reload();
    } else {
      await Updates.reloadAsync();
    }
  }

  const handleLoading = () => {
    return (
      <View style={{ height: '100%', backgroundColor: '#fff', justifyContent: 'space-between' }}>
        <View style={{ height: '87%', alignItems: 'center', justifyContent: 'center' }}>
          <Image source={Logo} style={{ width: 140, height: 101 }} />
        </View>
        <View style={{ height: '13%', alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ fontSize: 16, color: '#292D32', fontFamily: 'IRANSans_Bold' }}>پنل کارشناسان</Text> 
          <Image source={LoadingImage} style={{ width: 50, height: 50 }} />
        </View>
      </View>
    );
  }

  const handleOpenGps = () => {
    return(
      <View style={{ flex: 1, alignItems: 'center', backgroundColor: '#fff', justifyContent: 'center' }}>
        <Image source={NoGPS} style={{ width: 200, height: 160 }} />
        <Text style={{ fontSize: 16, color: '#656564', fontFamily: 'IRANSans_Medium' }}>عدم دسترسی به لوکیشن!</Text>
        <Text style={{ fontSize: 12, color: '#656564', marginTop: 4, marginBottom: 24 }}>کارشناس گرامی برای ثبت آگهی اپلیکیشن نیاز به دسترسی لوکیشن دارد.</Text>
        <Button onPress={openGps} labelStyle={{ fontSize: 16 }} style={{ width: '48%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained">بازکردن لوکیشن</Button>
      </View>
    );
  }

  const openGps = async () => {
    try {
      await Location.getCurrentPositionAsync({});
      setIsGpsOpen(false);
    } catch (error) {
      setIsGpsOpen(true);
    }
  }

  const gregorian_to_jalali = (gy, gm, gd) => {
    var g_d_m, jy, jm, jd, gy2, days;
    g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    gy2 = (gm > 2) ? (gy + 1) : gy;
    days = 355666 + (365 * gy) + ~~((gy2 + 3) / 4) - ~~((gy2 + 99) / 100) + ~~((gy2 + 399) / 400) + gd + g_d_m[gm - 1];
    jy = -1595 + (33 * ~~(days / 12053));
    days %= 12053;
    jy += 4 * ~~(days / 1461);
    days %= 1461;
    if (days > 365) {
        jy += ~~((days - 1) / 365);
        days = (days - 1) % 365;
    }
    if (days < 186) {
        jm = 1 + ~~(days / 31);
        jd = 1 + (days % 31);
    } else {
        jm = 7 + ~~((days - 186) / 30);
        jd = 1 + ((days - 186) % 30);
    }
    return jy + '/' + jm + '/' + jd;
  }

  const updateInApp = async () => {
    await Updates.fetchUpdateAsync();
    await Updates.reloadAsync();
    setIsInAppUpdateOn(false);
  }

  return (
    <MainContext.Provider
      value={{
        setUserData: setUserData,
        activateSnackbar: setSnackbarActive,   
        setUserRole: setRole,
        handleAxiosError: handleAxiosError,
        setAddAdsFormActive: setAddAdsFormActive,
        setAddAdsForm: saveAddAdsForm,
        setAddCustomerActive: setAddCustomerActive,
        setAddCustomerForm: saveAddCustomerForm,
        setAppDataLoad: setAppDataLoad,
        userData,
        role,
        addsTypes,
        locationData,
        snackbar,
        addAdsFormActive,
        addAdsForm,
        addCustomerActive,
        addCustomerForm,
        appDataLoad
      }}
    >
      {
        isOffline ?
          handleOfflinePage()
        :
          isGpsOpen ?
            handleOpenGps()
          :
            !appDataLoad ?
              handleLoading()
            :
              isDisable ?
                handleDisablePage()
              :
                isError500 ?
                  handleError500()
                :
                  isBirthday ?
                    handleBirthDay(birthdayStep)
                  :
                    <KeyboardAvoidingView 
                      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
                      style={{ flex: 1 }}
                    >
                      {props.children}
                    </KeyboardAvoidingView>
      }
      <Portal>
        <Dialog visible={isInAppUpdateOn} onDismiss={() => {}}>
          <Dialog.Title style={{ fontSize: 14, fontFamily: 'IRANSans_Medium', color: '#555' }}>آپدیت درون برنامه‌ای</Dialog.Title>
          <Dialog.Content>
            <Text variant="bodyMedium" style={{ fontSize: 12, fontFamily: 'IRANSans_Medium', color: '#666', fontFamily: 'IRANSans', textAlign: 'justify' }}>آپدیت درون برنامه‌ای بزودی شروع میشود، طول این مدت کوتاه ممکن است اپلیکیشن دچار اختلال شود.</Text>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => updateInApp()}>بروزرسانی کن</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
    </MainContext.Provider>
  );
}

export default MainContextProvider;

export const MainConsumer = MainContext.Consumer;
